import { Input, SegmentedControl, Switch, Text } from '@byecode/ui'
import { DEFAULT_CAROUSEL_VIEW_OPTIONS } from '@lighthouse/core'
import { Group4ByecodeUi, ListItem4ByecodeUi } from '@lighthouse/shared'
import React from 'react'
import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { InheritLabel } from '@/components/InheritLabel'
import { useSetExtendsKeys } from '@/components/StyleSetting/hooks/useMouseEventDistance'

const FIELD_PREFIX = 'breakPoint.viewLayout.carousel'
type CarouselSwitchField = 'autoplay' | 'loop' | 'navigation' | 'pagination' | 'swipe'

export const CarouselSetting: React.FC = () => {
    const { control } = useFormContext()
    const { handleSetBreakKey } = useSetExtendsKeys()
    const autoplay = useWatch({ control, name: `${FIELD_PREFIX}.autoplay` }) ?? DEFAULT_CAROUSEL_VIEW_OPTIONS.autoplay

    const renderSwitch = (name: CarouselSwitchField, label: string) => (
        <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
            <InheritLabel label={label} name={`${FIELD_PREFIX}.${name}`} />
            <Controller
                control={control}
                name={`${FIELD_PREFIX}.${name}`}
                render={({ field }) => (
                    <Switch
                        checked={field.value ?? DEFAULT_CAROUSEL_VIEW_OPTIONS[name]}
                        onChange={event => {
                            field.onChange(event.currentTarget.checked)
                            handleSetBreakKey(`${FIELD_PREFIX}.${name}`)
                        }}
                    />
                )}
            />
        </ListItem4ByecodeUi>
    )

    return (
        <Group4ByecodeUi label="轮播设置">
            {renderSwitch('autoplay', '自动播放')}
            {autoplay && (
                <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                    <InheritLabel label="播放间隔" name={`${FIELD_PREFIX}.interval`} />
                    <Controller
                        control={control}
                        name={`${FIELD_PREFIX}.interval`}
                        render={({ field }) => (
                            <Input
                                type="number"
                                min={0.1}
                                step={0.1}
                                style={{ width: 180 }}
                                value={field.value ?? DEFAULT_CAROUSEL_VIEW_OPTIONS.interval}
                                suffix={<Text>s</Text>}
                                onChange={event => {
                                    field.onChange(Number(event.currentTarget.value))
                                    handleSetBreakKey(`${FIELD_PREFIX}.interval`)
                                }}
                            />
                        )}
                    />
                </ListItem4ByecodeUi>
            )}
            <ListItem4ByecodeUi justifyContent="space-between" alignItems="center">
                <InheritLabel label="切换效果" name={`${FIELD_PREFIX}.effect`} />
                <Controller
                    control={control}
                    name={`${FIELD_PREFIX}.effect`}
                    render={({ field }) => (
                        <SegmentedControl
                            style={{ width: 180 }}
                            fullWidth
                            data={[
                                { label: '滑动', value: 'slide' },
                                { label: '滑动渐隐', value: 'creative' }
                            ]}
                            value={field.value ?? DEFAULT_CAROUSEL_VIEW_OPTIONS.effect}
                            onChange={value => {
                                field.onChange(value)
                                handleSetBreakKey(`${FIELD_PREFIX}.effect`)
                            }}
                        />
                    )}
                />
            </ListItem4ByecodeUi>
            {renderSwitch('loop', '循环播放')}
            {renderSwitch('navigation', '切换按钮')}
            {renderSwitch('pagination', '分页指示器')}
            {renderSwitch('swipe', '滑动切换')}
        </Group4ByecodeUi>
    )
}
